export const BREAKPOINTS = {
    extra_small: 320,
    mobile: 480,
    tablet: 599, // Purpur MD breakpoint - 1px
    desktop: 1023, // Purpur LG breakpoint - 1px
    large: 1439, // Purpur XL breakpoint - 1px
};

export const isMobile = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

export const isIE = () => /MSIE|Trident/.test(navigator.userAgent);

export const isResMoreThanExtraSmall = () => window.innerWidth > BREAKPOINTS.extra_small;

export const isMobileRes = () => window.innerWidth <= BREAKPOINTS.tablet;

export const isTabletRes = () => window.innerWidth > BREAKPOINTS.tablet && window.innerWidth <= BREAKPOINTS.desktop;

export const isDesktopRes = () => window.innerWidth > BREAKPOINTS.desktop;

export const isLargeDesktopRes = () => window.innerWidth > BREAKPOINTS.large;

export const isMobileOrTabletRes = () => isMobileRes() || isTabletRes();
